import { useMemo } from 'react';
import { Account, Plan, PlanInterval } from '../interfaces';

export const ACCOUNT_PLANS: Record<string, Plan> = {
    GROW: {
        NAME: 'Grow Plan',
        CODE: 'grow',
        PRICE: 5,
        ORIGIN_PRICE: 13,
        INTERVAL: PlanInterval.MONTH,
        INTERVAL_COUNT: 30,
        LIMIT: {
            USERS: -1,
            LIVE_MENU: -1,
            ITEMS: -1,
        },
    },
    FREE: {
        NAME: 'Free Plan',
        CODE: 'free',
        PRICE: 0,
        LIMIT: {
            USERS: 2,
            LIVE_MENU: 1,
            ITEMS: 50,
        },
    },
};

export type UseCanUpgradeParams = {
    account?: Pick<Account, 'planExpiredAt' | 'planCode'>;
};

export const useCanUpgrade = ({ account }: UseCanUpgradeParams) => {
    return useMemo(() => {
        return (
            (account && (!account.planExpiredAt || new Date(account.planExpiredAt) <= new Date())) ||
            account?.planCode === ACCOUNT_PLANS.FREE.CODE
        );
    }, [account]);
};
